import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/78_card_back_autumn/78_card_back_autumn"
 * Contains 1 texture(s)
 */
export class CardsBacks78CardBackAutumnAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/78_card_back_autumn/78_card_back_autumn';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '78_autumn.png'
    ] as const;
}
